// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"style_skeleton__63VgY"};